// src/renderer/app/listenerMiddleware.ts
import { setDefaultServer, setGPUAccelerationFlag, setRenderingQualityType } from "@features/analysis/analysisModal/SettingsModal/SettingsModalSlice";
import { createListenerMiddleware, Dispatch, TypedStartListening, UnknownAction } from "@reduxjs/toolkit";
import { setViewportNegative, setViewportsNegative, updateViewportsWindowLevel, updateViewportsWindowLevelWidth, updateViewportsWindowWidth, updateViewportThickness, updateViewportThicknessMethod  } from "@features/analysis/rendering/Panels/Renderers/CornerstoneManager";
import {   resetSelectedSeriesLayout,  setSelectedAnalysis, updateCPRStateIndexedState, updateCPRStateIndexedStates, updatePanelStateChamberViewProps, updatePanelStates, updatePanelStateSegmentation, updatePanelStateThickness, updatePanelStateThicknessMethod, updatePanelStateZoom,  updateSwitchConfigTarget, updateUIConfigVOIInvert, updateUIConfigVOIWindowLevel, updateUIConfigVOIWindowLevelWidth, updateUIConfigVOIWindowWidth } from "@features/analysis/AnalysisPageSlice";
import { setSelectedStudy } from "@features/browser/BrowserPageSlice";
import {rootReducer} from "./rootReducer";
import { configStore } from "config/configStore";


// export const listener = createListenerMiddleware<RootState, AppDispatch>();

export type AppDispatch = Dispatch<UnknownAction>;
export type RootState = ReturnType<typeof rootReducer>;

export const listener = createListenerMiddleware<RootState, AppDispatch>();

type AppStartListening = TypedStartListening<RootState, AppDispatch>;
const startAppListening = listener.startListening as AppStartListening;

// setting
startAppListening({ actionCreator: setGPUAccelerationFlag, effect: ({payload}) => {
  console.debug('ㅎㅎ gpu 가속 바꿈',payload)
  // setGPUAcceleration(payload);
}});
startAppListening({ actionCreator: setRenderingQualityType, effect: ({payload}) => {
  console.debug('ㅎㅎ gpu 랜더퀄 바꿈',payload)
  // setRenderingQuality(payload);
}});

startAppListening({ actionCreator: updatePanelStates,
  effect: async (action,{dispatch}) => {
    console.debug('패널 바뀌었어용.',action.payload)
  if(Object.keys(action.payload).length == 1){
    //console.log('리셋이 아니쥬?',action.type)

  }
}});
startAppListening({ actionCreator: updatePanelStateChamberViewProps,
  effect: async (action,{dispatch}) => {
    // const [viewportId,chamberViewProps]=action.payload;
    // const tp = [0,0,0] as [number,number,number]
    // getInvisibleSection({
    //   viewportId,
    //   pixelSpacing:tp,
    //   imageSize:chamberViewProps.imageSize!
    // })
    // console.log('updateViewportThickness',viewportId, thickness)
  // updateViewportThickness(viewportId,thickness);
}});
startAppListening({ actionCreator: updatePanelStateThickness,
  effect: async (action,{dispatch}) => {
    const [viewportId, thickness] = action.payload;
    // console.log('updateViewportThickness',viewportId, thickness)
    //여기서 반만 줘버리기.
    updateViewportThickness(viewportId,thickness*0.5);
}});
startAppListening({ actionCreator: updatePanelStateThicknessMethod,
  effect: async (action,{dispatch}) => {
    const [viewportId, thicknessMethod] = action.payload;
    // console.log('updateViewportThicknessMethod',viewportId, thicknessMethod)
  updateViewportThicknessMethod(viewportId,thicknessMethod);
}});
startAppListening({ actionCreator: updatePanelStateZoom,
  effect: async (action,{dispatch}) => {
    const [viewportId, zoom] = action.payload;
    // console.log('updateViewportZoom',viewportId,zoom)
  // updateViewportZoom(viewportId,zoom);
}});
// startAppListening({ actionCreator: updatePanelStateWindowLevel,
//   effect: async (action,{dispatch}) => {
//     //console.log('updateViewportWindowLevel')
//   const [viewportId, windowLevel] = action.payload;
//   if(viewportId === 'Axial' ||viewportId === 'Coronal'||viewportId === 'Sagittal'){
//     updateViewportWindowLevel(viewportId,windowLevel);
//   }

// }});
// startAppListening({ actionCreator: updatePanelStateWindowWidth,
//   effect: async (action,{dispatch}) => {
//     //console.log('updateViewportWindowWidth')
//   const [viewportId, windowWidth] = action.payload;
//   if(viewportId === 'Axial' ||viewportId === 'Coronal'||viewportId === 'Sagittal'){
//     updateViewportWindowWidth(viewportId,windowWidth);
//   }

// }});
// startAppListening({ actionCreator: updatePanelStateWindowLevelWidth,
//   effect: async (action,{dispatch}) => {
//     //console.log('updateViewportWindowWidth')
//   const [viewportId, windowLevel, windowWidth] = action.payload;
//   if(viewportId === 'Axial' ||viewportId === 'Coronal'||viewportId === 'Sagittal'){
//     updateViewportWindowLevelWidth(viewportId, windowLevel, windowWidth);
//   }

// }});

// 따로 쓸일이 있을까
// startAppListening({ actionCreator: updateUIConfigVOIWindowLevel,
//   effect: async (action,{dispatch}) => {
//   updateViewportsWindowLevel(action.payload);
// }});
// startAppListening({ actionCreator: updateUIConfigVOIWindowWidth,
//   effect: async (action,{dispatch}) => {
//   updateViewportsWindowWidth(action.payload);
// }});

startAppListening({ actionCreator: updateUIConfigVOIWindowLevelWidth,
  effect: async (action,{dispatch}) => {
  // 코나스톤 전부 바꿔버리기
  const [windowLevel, windowWidth] = action.payload;
  updateViewportsWindowLevelWidth(windowLevel, windowWidth);

  // 스케줄 쏴보기?
}});
startAppListening({ actionCreator: updateUIConfigVOIInvert,
  effect: async (action,{dispatch}) => {
  setViewportsNegative(action.payload);
}});

// startAppListening({ actionCreator: updatePanelStatePreset,
//   effect: async (action,{dispatch}) => {
//     //console.log('updatePanelStatePreset')
//   const [viewportId, preset] = action.payload;
// }});

startAppListening({actionCreator:updatePanelStateSegmentation,
  effect: async (action, {dispatch})=>{
    const [key,partialSegmentation] = action.payload;

    //무조건 하나걸림
    // Object.entries(partialSegmentation).forEach(async ([type,value])=>{
    //   updateLabelSegmentationConfig(key,type as keyof SegmentationProps, value)
    //   // switch(type as keyof SegmentationProps){
    //   //   case "color":
    //   //     updateLabelSegmentationColor(key,value as SegmentationProps['color'])
    //   //     break;
    //   //   case "opacity":
    //   //     break;
    //   //   case "visibility":
    //   //     break;
    //   // }
    // })

  }
})
startAppListening({ actionCreator: updateCPRStateIndexedState,
  effect: async (action,{dispatch}) => {
    //console.log('updateViewportWindowWidth')
  // console.log('왔냐왔냐111')

}});
startAppListening({ actionCreator: updateCPRStateIndexedStates,
  effect: async (action,{dispatch}) => {
    //console.log('updateViewportWindowWidth')
  // console.log('왔냐왔냐222',action.payload)

}});
// startAppListening({ actionCreator: updateSwitchConfigTarget,
//   effect: async (action,{dispatch}) => {
//     //console.log('updateSwitchConfig')
//   const [switchConfig,viewportId] = action.payload;
//   const {switchCTNegativeIntensity} = switchConfig;
//   if(viewportId && switchCTNegativeIntensity!==undefined){
//     setViewportNegative(viewportId,switchCTNegativeIntensity);
//   }
// }});


startAppListening({ actionCreator: setSelectedAnalysis,
  effect: async (action,{dispatch}) => {
  console.debug('분석 바뀌었어용.')
}});


startAppListening({ actionCreator: setSelectedStudy,
  effect: async (action,{dispatch}) => {
    dispatch(resetSelectedSeriesLayout());
    // clearCornerstoneResource()
    // const {clearBufferPool} = useBufferPool();
    // clearBufferPool();

  console.log('스터디 새로클릭?? 이전꺼 다지워버립니다.',action)
}});
// startAppListening({ actionCreator: addRecentStudy,
//   effect: async (action,{dispatch}) => {
//   const selectedStudyId = action.payload;
//   // dispatch(resetSelectedStudyId());
//   dispatch(resetSelectedSeriesLayout());
//   console.debug('addRecentStudy를 통한 스터디 새로클릭')
// }});

startAppListening({ actionCreator: setDefaultServer, effect: ({payload}) => {
  console.debug('ㅎㅎ gpu 랜더퀄 바꿈',payload);
  configStore.setData({ defaultServer: payload });     // 쓰기
}});

// 값 추적 유용함
startAppListening({
  predicate: (action, currentState, previousState) => {

    return (
      currentState.analysis.panelStates.CPR.coronary?.current[0] !== previousState.analysis.panelStates.CPR.coronary?.current[0]||
      currentState.analysis.panelStates.CPR.coronary?.current[1] !== previousState.analysis.panelStates.CPR.coronary?.current[1]||
      currentState.analysis.panelStates.CPR.coronary?.current[2] !== previousState.analysis.panelStates.CPR.coronary?.current[2]);
  },
  effect: (action, listenerApi) => {
    const { currentState, previousState } = { currentState: listenerApi.getState(), previousState: listenerApi.getOriginalState() }
    const prevValue = listenerApi.getOriginalState().analysis.panelStates.CPR.coronary?.current;
    const nextValue = listenerApi.getState().analysis.panelStates.CPR.coronary?.current;

    console.group(`값이 변경됨! (Action: ${action.type})`);
    console.log('이전 값:', prevValue);
    console.log('변경된 값:', nextValue);
    console.log('원인 액션:', action);
    console.trace('호출 스택 추적');
    console.groupEnd();
  }
});
